
import React from 'react'
import { Routes, Route } from 'react-router-dom'

import { EquipmentAndMovementList } from './CONTAINERCONTROL/equipmentAndMovementList'
import { EquipmentAndMovementCrud } from './CONTAINERCONTROL/equipmentAndMovementCrud.jsx'
import { EquipmentServiceList } from './CONTAINERCONTROL/equipmentServiceList.jsx'
import { EquipmentServiceCrud } from './CONTAINERCONTROL/equipmentServiceCrud.jsx'
import { EquipmentTypeList } from './CONTAINERCONTROL/equipmentTypeList'
import { EquipmentTypeCrud } from './CONTAINERCONTROL/equipmentTypeCrud'
import { EquipmentStatusList } from './CONTAINERCONTROL/equipmentStatusList'
import { EquipmentStatusCrud } from './CONTAINERCONTROL/equipmentStatusCrud'
import { EquipmentClassList } from './CONTAINERCONTROL/equipmentClassList'
import { EquipmentClassCrud } from './CONTAINERCONTROL/equipmentClassCrud'
import { EquipmentLeasingList } from './CONTAINERCONTROL/equipmentLeasingList'
import { EquipmentLeasingCrud } from './CONTAINERCONTROL/equipmentLeasingCrud'
import { EquipmentConditionList } from './CONTAINERCONTROL/equipmentConditionList'
import { EquipmentConditionCrud } from './CONTAINERCONTROL/equipmentConditionCrud'

import { LastMovementList } from './CONTAINERCONTROL/lastMovementList.jsx'
import { LastMovementCrud } from './CONTAINERCONTROL/lastMovementCrud.jsx'
import { RangeMovementList } from './CONTAINERCONTROL/rangeMovementList.jsx'
import { MovementTypeList } from './CONTAINERCONTROL/movementTypeList.jsx'
import { MovementTypeCrud } from './CONTAINERCONTROL/movementTypeCrud.jsx'
import { MovementTypeEquipmentStatusList } from './CONTAINERCONTROL/movTypeEqStatusList'
import { MovementTypeEquipmentStatusCrud } from './CONTAINERCONTROL/movTypeEqStatusCrud'
import { SequenceMovementList } from './CONTAINERCONTROL/sequenceMovementList.jsx'
import { SequenceMovementCrud } from './CONTAINERCONTROL/sequenceMovementCrud.jsx'

import { DemurrageRuleList } from './CONTAINERCONTROL/demurrageRuleList.jsx'
import { DemurrageRuleCrud } from './CONTAINERCONTROL/demurrageRuleCrud.jsx'
import { DemurrageControlList } from './CONTAINERCONTROL/demurrageControlList.jsx'
import { DemurrageControlCrud } from './CONTAINERCONTROL/demurrageControlCrud.jsx'
import { DemurrageMovementList } from './CONTAINERCONTROL/demurrageMovementList.jsx'

import { TransportList } from './CONTAINERCONTROL/transportList'
import { TransportCrud } from './CONTAINERCONTROL/transportCrud'

import { EquipmentCostRuleList } from './CONTAINERCONTROL/equipmentCostRuleList'
import { EquipmentCostRuleCrud } from './CONTAINERCONTROL/equipmentCostRuleCrud'
import { EquipmentCostDetailList } from './CONTAINERCONTROL/equipmentCostDetailList'

import { LocationRestrictionList } from './CONTAINERCONTROL/locationRestrictionList.jsx'
import { LocationRestrictionCrud } from './CONTAINERCONTROL/locationRestrictionCrud.jsx'



export default function ContainerControl(props) {

    return(
        <>
            <div className='baseLineSubmenus'>
                <Routes>
                    <Route path='equipmentAndMovementList' element={<EquipmentAndMovementList roles={props.roles} />} />
                    <Route path='equipmentAndMovementCrud' element={<EquipmentAndMovementCrud roles={props.roles} />} />

                    <Route path='equipmentTypeList' element={<EquipmentTypeList roles={props.roles} />} />
                    <Route path='equipmentTypeCrud' element={<EquipmentTypeCrud roles={props.roles} />} />
                    <Route path='equipmentClassList' element={<EquipmentClassList roles={props.roles} />} />
                    <Route path='equipmentClassCrud' element={<EquipmentClassCrud roles={props.roles} />} />
                    <Route path='equipmentStatusList' element={<EquipmentStatusList roles={props.roles} />} />
                    <Route path='equipmentStatusCrud' element={<EquipmentStatusCrud roles={props.roles} />} />
                    <Route path='equipmentServiceList' element={<EquipmentServiceList roles={props.roles} />} />
                    <Route path='equipmentServiceCrud' element={<EquipmentServiceCrud roles={props.roles} />} />
                    <Route path='equipmentLeasingList' element={<EquipmentLeasingList roles={props.roles} />} />
                    <Route path='equipmentLeasingCrud' element={<EquipmentLeasingCrud roles={props.roles} />} />
                    <Route path='equipmentConditionList' element={<EquipmentConditionList roles={props.roles} />} />
                    <Route path='equipmentConditionCrud' element={<EquipmentConditionCrud roles={props.roles} />} />

                    <Route path='lastMovementList' element={<LastMovementList roles={props.roles} />} />
                    <Route path='lastMovementCrud' element={<LastMovementCrud roles={props.roles} />} />
                    <Route path="rangeMovementList" element={<RangeMovementList roles={props.roles} />} />
                    <Route path='movementTypeList' element={<MovementTypeList roles={props.roles} />} />
                    <Route path='movementTypeCrud' element={<MovementTypeCrud roles={props.roles} />} />
                    <Route path='movTypeEqStatusList' element={<MovementTypeEquipmentStatusList roles={props.roles} />} />
                    <Route path='movTypeEqStatusCrud' element={<MovementTypeEquipmentStatusCrud roles={props.roles} />} />
                    <Route path='sequenceMovementList' element={<SequenceMovementList roles={props.roles} />} />
                    <Route path='sequenceMovementCrud' element={<SequenceMovementCrud roles={props.roles} />} />

                    <Route path='demurrageControlList' element={<DemurrageControlList roles={props.roles} />} />
                    <Route path='demurrageControlCrud' element={<DemurrageControlCrud roles={props.roles} />} />
                    <Route path='demurrageRuleList' element={<DemurrageRuleList roles={props.roles} />} />
                    <Route path='demurrageRuleCrud' element={<DemurrageRuleCrud roles={props.roles} />} />
                    <Route path='demurrageMovementList' element={<DemurrageMovementList roles={props.roles} />} />
                    

                    <Route path='transportList' element={<TransportList roles={props.roles} />} />
                    <Route path='transportCrud' element={<TransportCrud roles={props.roles} />} />
                    <Route path='equipmentCostRuleList' element={<EquipmentCostRuleList roles={props.roles} />} />
                    <Route path='equipmentCostRuleCrud' element={<EquipmentCostRuleCrud roles={props.roles} />} />
                    <Route path='equipmentCostDetailList' element={<EquipmentCostDetailList roles={props.roles} />} />

                    <Route path='locationRestrictionList' element={<LocationRestrictionList roles={props.roles} />} />
                    <Route path='locationRestrictionCrud' element={<LocationRestrictionCrud roles={props.roles} />} />
                </Routes>
            </div>
        </>
    )
}
